import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { StateService } from "@core-services/state.service";
import { CashPlusConfigurationsApi } from "@modules/cashplus/entities/cashplus.model";

export interface CashPlusConfigurationState extends CashPlusConfigurationsApi {
	error: boolean;
	lowestAPR?: number;
}

const initialState: CashPlusConfigurationState | null = null;

@Injectable({
	providedIn: "root"
})
export class CashPlusConfigurationStateService extends StateService<CashPlusConfigurationState> {
	public constructor() {
		super(initialState);
	}

	public getState$(): Observable<CashPlusConfigurationState> {
		return this.select((state) => state);
	}

	public updateState(model: CashPlusConfigurationState): void {
		this.setState(model);
	}

	public hasError(): boolean {
		return this.state?.error;
	}

	public isConfigurationLoaded(): boolean {
		return this.isStateLoaded();
	}
}
